import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMap } from "@fortawesome/free-solid-svg-icons";
import { modulo3 } from "../../routes/Module3";
import LayoutActividad from "../../components/LayoutActividad";
import Sidebar from "./Sidebar";
import Imagen from "../../images/modulo3/miescuela.png";
import GuiaDocente from "../../components/GuiaDocente";
import AudioPlayer from "../../audioPlayer/AudioPlayer";
import Audio from "../../audios/modulo3/Inicio.mp3";

const Modulo1 = () => {
  const nextUnity = modulo3.content[0];
  const nextActivity = nextUnity.activities[0];

  const pages = {
    titleNext: `${nextActivity.name}`,
    linkNext: `${modulo3.url}/${nextUnity.path}/${nextActivity.path}`,
  };
  const crumbs = [
    {
      title: `${modulo3.title} > Inicio `,
      url: "/" + modulo3.url,
    },
  ];
  const metadata = {
    color: modulo3.color,
    title: `${modulo3.title}`,
    name: modulo3.title
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <div>
        <h1 className="my-5">{modulo3.title}</h1>
        <AudioPlayer track={Audio} />

      </div>

      <div className="header-img">
        <img src={Imagen} className="card-img-top full-width" alt="..." />
      </div>
      <div className="row mt-4">
        <div className="col-md-8 col-sm-12">
          <p>
            En este módulo, aprenderemos que existen distintas escuelas que
            acogen a una diversidad de niños y niñas de todo nuestro país.
            Además, comprenderemos que tenemos deberes y derechos que son
            necesarios para que podamos convivir en la escuela.
          </p>
        </div>
      </div>

      <div className="unit-options mb-5 mt-2 d-flex">
        <a href={"https://ciudadania.pe/actividades-interactivas/" + pages.linkNext}>
          <button className={`btn btn-${modulo3.color} me-2`}>
            Empezar actividades <FontAwesomeIcon icon={faMap} />
          </button>
        </a>
      </div>
      <GuiaDocente>
        <p>
          Lea el título de este módulo y observen la ilustración. Pregunte qué
          es lo que se observa en la imagen. Enfatice que se trata de
          estudiantes con características distintas que conviven diariamente en
          un solo lugar: la escuela. Termine leyendo el texto que aparece debajo
          de la ilustración.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Modulo1;
